import { handleRequest } from "../utilities/requestHandler";

/**
 * Fetch every blocked public-registration email domain.
 *
 * Lives in its own table rather than the `options` row it replaced: the old
 * free-text option was overwritten with a blank string by a Settings save that
 * ran before the options had loaded, which silently let personal-email signups
 * through. Rows can only be added or removed one at a time, so a stale form can
 * no longer wipe the list.
 *
 * @returns {Promise<Object>} `{ status, message, data: [{ id, domain, created_by, created_by_name, created_at, updated_by, updated_by_name }] }`, sorted by domain. Non-super-admins get `{ status: false, message }` (403).
 */
export const getBlockedDomains = () =>
	handleRequest("get", "/registration-blocked-domains");

/**
 * Block one or more email domains.
 *
 * @param {string[]} domains Domains to block; the server normalises, de-duplicates and validates them.
 * @returns {Promise<Object>} `{ status, message, data: { domains, added, already_blocked, invalid } }` — `data.domains` is the full refreshed list, so callers render it instead of refetching.
 */
export const addBlockedDomains = (domains) =>
	handleRequest("post", "/registration-blocked-domains", { domains });

/**
 * Unblock a single domain by row id.
 *
 * @param {number|string} id Row id from `getBlockedDomains`.
 * @returns {Promise<Object>} `{ status, message, data: { domains } }` — the refreshed list after removal.
 */
export const removeBlockedDomain = (id) =>
	handleRequest("delete", `/registration-blocked-domains/${id}`);
